import React, { useEffect, useContext, useState } from "react";
import { useTranslation } from "react-i18next";
import FormDataContext from "integrations/contexts/FormDataContext";
import { salesforce } from "@graylog/enterprise-api";
import { Input } from "components/bootstrap";
import Select from "components/common/Select";
import FormAdvancedOptions from "./FormAdvancedOptions";
import INITIAL_FORMDATA from "./_initialFormData";
import FormWrap from "../common/FormWrap";
const StepSubscribe = ({ onSubmit, onChange }) => {
  const { t } = useTranslation("enterprise_integrations");
  const { formData } = useContext(FormDataContext);
  const [formError, setFormError] = useState(null);
  const { pollingInterval } = formData;
  const [contentTypes, setContentTypes] = useState(INITIAL_FORMDATA.availableContents.value);
  const { setFormData } = useContext(FormDataContext);
  const [regions, setRegions] = useState([]);
  useEffect(() => {
    salesforce.getLogTypes().then((response) => {
      const region = Object.keys(response).map((key) => ({ label: key, value: response[key] }));
      const sortedRegion = [...region];
      sortedRegion.sort((a, b) => {
        const labelA = a.label.toLowerCase();
        const labelB = b.label.toLowerCase();
        return labelA.localeCompare(labelB);
      });
      setRegions(sortedRegion);
    });
  }, []);
  const handleSubmit = () => {
    if (pollingInterval.value >= 5) {
      setFormError(null);
      onSubmit();
    } else {
      setFormError({
        full_message: t("salesforce.subscribe.invalid_polling_interval_message"),
        nice_message: t("salesforce.subscribe.min_polling_interval")
      });
    }
  };
  const handleContentType = (val) => {
    const value = { value: val, dirty: false };
    setFormData("logTypes", value);
    setContentTypes(val);
  };
  return /* @__PURE__ */ React.createElement(
    FormWrap,
    {
      onSubmit: handleSubmit,
      buttonContent: t("common.buttons.proceed"),
      title: "",
      error: formError,
      description: ""
    },
    /* @__PURE__ */ React.createElement("label", { className: "control-label", htmlFor: "contents" }, t("salesforce.subscribe.log_types_label")),
    /* @__PURE__ */ React.createElement(
      Select,
      {
        multi: true,
        name: "log_types",
        id: "log_types",
        options: regions,
        value: contentTypes || "",
        onChange: handleContentType
      }
    ),
    /* @__PURE__ */ React.createElement("span", { className: "help-block" }, t("salesforce.subscribe.log_types_help")),
    /* @__PURE__ */ React.createElement(
      Input,
      {
        id: "pollingInterval",
        name: "pollingInterval",
        type: "number",
        value: pollingInterval.value || pollingInterval.defaultValue || "",
        min: "1",
        max: "60",
        step: "1",
        onChange,
        required: true,
        help: t("salesforce.subscribe.polling_interval_help"),
        label: t("common.fields.polling_interval")
      }
    ),
    /* @__PURE__ */ React.createElement(FormAdvancedOptions, { onChange })
  );
};
export default StepSubscribe;
